const REQUIRED_MESSAGE = '服务费金额不能为空';

export const isConsumerTopUp = (row, changeType) => (
  Boolean(row && String(row.poolAccountType) === '2' && String(changeType) === '1')
);

export const createBasicChargeAmountRule = (required = true) => ({
  type: 'inputNumber',
  field: 'basicChargeAmount',
  title: '服务费金额',
  required,
  value: '',
  props: {
    clearable: true,
    controls: false,
    min: 0,
    precision: 2,
    required,
  },
  validate: [
    {
      trigger: 'blur',
      required,
      message: REQUIRED_MESSAGE,
    },
  ],
});

export const getAdjustmentFieldState = (row, changeType) => {
  const showBasicChargeAmount = isConsumerTopUp(row, changeType);
  return {
    amountTitle: showBasicChargeAmount ? '上账金额' : '金额',
    showBasicChargeAmount,
    basicChargeAmountRequired: showBasicChargeAmount,
  };
};

export const getBasicChargeAmountValidation = (required) => ([
  {
    trigger: 'blur',
    required,
    message: REQUIRED_MESSAGE,
  },
]);
